module.exports = __webpack_public_path__ + "media/src/assets/images/shop-info-e4e0fb90975c7c19d6b2576158f580e9.png";